module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<xml id="toolbox" style="display: none;">\n  <block type="maze_moveForward"></block>\n  <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n  <block type="maze_turn"><title name="DIR">turnRight</title></block>\n  <% if (page === 1) { -%>\n    <% if (level > 2) { -%>\n      <block type="maze_forever"></block>\n      <% if (level === 5) { -%>\n        <block type="maze_if"><title name="DIR">isPathLeft</title></block>\n      <% } else if (level > 5 && level < 9) { -%>\n        <block type="maze_if"></block>\n      <% } -%>\n      <% if (level > 8) { -%>\n       <block type="maze_ifElse"></block>\n      <% } -%>\n    <% } -%>\n  <% } else if (page === 2) { -%>\n    <% if (level > 4 && level < 9) { -%>\n      <block type="controls_repeat">\n        <title name="TIMES">5</title>\n      </block>\n    <% } -%>\n    <% if (level > 8) { -%>\n      <block type="maze_forever"></block>\n      <% if (level === 13 || level === 15) { -%>\n        <block type="maze_if"><title name="DIR">isPathLeft</title></block>\n      <% } else if (level === 14 || level === 16) { -%>\n        <block type="maze_if"><title name="DIR">isPathRight</title></block>\n      <% } -%>\n      <% if (level > 16) { -%>\n       <block type="maze_ifElse"></block>\n      <% } -%>\n    <% } -%>\n  <% } -%>\n</xml>\n', __filename = "src/maze/toolboxes/maze.xml.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __append('<xml id="toolbox" style="display: none;">\n  <block type="maze_moveForward"></block>\n  <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n  <block type="maze_turn"><title name="DIR">turnRight</title></block>\n  ');
            __line = 5;
            if (page === 1) {
                __append("    ");
                __line = 6;
                if (level > 2) {
                    __append('      <block type="maze_forever"></block>\n      ');
                    __line = 8;
                    if (level === 5) {
                        __append('        <block type="maze_if"><title name="DIR">isPathLeft</title></block>\n      ');
                        __line = 10;
                    } else if (level > 5 && level < 9) {
                        __append('        <block type="maze_if"></block>\n      ');
                        __line = 12;
                    }
                    __append("      ");
                    __line = 13;
                    if (level > 8) {
                        __append('       <block type="maze_ifElse"></block>\n      ');
                        __line = 15;
                    }
                    __append("    ");
                    __line = 16;
                }
                __append("  ");
                __line = 17;
            } else if (page === 2) {
                __append("    ");
                __line = 18;
                if (level > 4 && level < 9) {
                    __append('      <block type="controls_repeat">\n        <title name="TIMES">5</title>\n      </block>\n    ');
                    __line = 22;
                }
                __append("    ");
                __line = 23;
                if (level > 8) {
                    __append('      <block type="maze_forever"></block>\n      ');
                    __line = 25;
                    if (level === 13 || level === 15) {
                        __append('        <block type="maze_if"><title name="DIR">isPathLeft</title></block>\n      ');
                        __line = 27;
                    } else if (level === 14 || level === 16) {
                        __append('        <block type="maze_if"><title name="DIR">isPathRight</title></block>\n      ');
                        __line = 29;
                    }
                    __append("      ");
                    __line = 30;
                    if (level > 16) {
                        __append('       <block type="maze_ifElse"></block>\n      ');
                        __line = 32;
                    }
                    __append("    ");
                    __line = 33;
                }
                __append("  ");
                __line = 34;
            }
            __append("</xml>\n");
            __line = 36;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}